import React, { Suspense, lazy, useState, useEffect } from 'react';
import './App.scss';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getUser, getLoader } from './store/reducers';
import { getCookie } from 'utils/cookies';
import * as appActions from './store/actions';
import { withRouter, Switch, Route, Redirect } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import LoadingOverlay from 'react-loading-overlay';
import styled from 'styled-components';
import WELoader from 'components/UI/WELoader/WELoader';
import Utils from '../../utils/utils';
import MobileLayout from 'components/UI/AtomicDesign/Organism/MobileLayout';

const theme = createTheme({
  typography: {
    fontFamily: '"DM Sans", sans-serif',
  },
  palette: {
    primary: {
      light: '#616161',
      main: '#3A3A3A',
      dark: '#282828',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#528BF3',
      main: '#276EF1',
      dark: '#1B4DA8',
      contrastText: '#FFFFFF',
    },
    action: {
      light: '#FFFFFF',
      main: '#FFFFFF',
      dark: '#B2B2B2',
      contrastText: '#000000',
    },
  },
});

const StyledLoader = styled(LoadingOverlay)`
  ._loading_overlay_overlay {
    position: fixed;
    z-index: 1501;
  }
`;
const BookTruck = lazy(() => import('components/BookTruck/BookTruck'));
const AppHeader = lazy(() => import('components/AppHeader/AppHeader'));
const Login = lazy(() => import('components/Login/Login'));
const DetailsPage = lazy(() => import('components/Operations/DetailPage/detailsWrapper'));
const OldPortalRedirect = lazy(() => import('components/OldPortalRedirect/OldPortalRedirect'));
const Consigner = lazy(() => import('components/Consigner/Consigner'));
const Operations = lazy(() => import('components/Operations/Operations'));
const Placement = lazy(() => import('pages/Placement/Placement'));
const ThirdParty = lazy(() => import('components/ThirdParty/thirdParty'));
const CreateDemand = lazy(() => import('components/CreateDemand/createDemand'));
const UpdateVehicle = lazy(() => import('components/UpdateVehicle'));
const Operator = lazy(() => import('components/Operator/Operator'));
const Menu = lazy(() => import('components/Menu/Menu'));
const WebViews = lazy(() => import('components/WebViews/WebViews'));
const PlacementDetailPage = lazy(() => import('pages/Placement/Detail/DetailWrapper'));
const Toaster = lazy(() => import('components/Toaster'));

const Ticketing = lazy(() => import('pages/ticketing/ticketing'));
const TicketingDetail = lazy(() => import('pages/ticketing/Details/detailPage'));

/**Mobile Imports */
const PlacementMob = lazy(() => import('pages/mobile/placement'));
const PlacementDetailPageMob = lazy(() => import('pages/mobile/placement/details'));

const App = (props) => {
  const [showAppBar, setShow] = React.useState(getCookie('email') === '');
  const { location } = props;
  const [isMobile, setDevice] = useState(false);
  const [isAuth, setIsAuth] = useState(false);

  React.useEffect(() => {
    if (Utils.detectMob()) {
      setDevice(true);
    }
    if (
      (Utils.getUserDataFromLocal() || getCookie('email') !== '') &&
      !location.search.includes('token') &&
      !location.pathname.includes('/operations/details') &&
      !location.pathname.includes('/placement/details') &&
      !location.pathname.includes('/ticketing/details')
    ) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [location.search, location.pathname]);

  let routes = (
    <div className={showAppBar && !isMobile ? 'app-container' : 'mobile-view'}>
      {showAppBar && !isMobile && (
        <div className="left-nav-wrapper">
          <Menu handleLogout={() => Utils.reAuthenticate()} />
        </div>
      )}

      {/* {showAppBar && isMobile && <MobLayout />} */}

      {showAppBar && !isMobile && (
        <div className="right-card-content">
          <AppHeader />
        </div>
      )}

      <Switch>
        <Redirect exact from="/" to="/portal/placement" />
        <Route className="component-body" path="/portal/consigner" component={Consigner} />
        <Route className="component-body" path="/portal/book-truck" component={BookTruck} />
        <Route className="component-body" path="/portal/operator" component={Operator} />
        <Route className="component-body" exact path="/portal/operations" component={Operations} />
        {/* <Route className="component-body" exact path="/portal/operations" component={Operations} /> */}

        <Route
          className="component-body"
          exact
          path="/portal/ticketing"
          component={isMobile ? PlacementMob : Placement}
        />
        <Route className="component-body" exact path="/portal/ticketing" component={Ticketing} />
        <Route path="/portal/ticketing/details" component={TicketingDetail} />
        <Route path="/portal/operations/details" component={DetailsPage} />
        <Route path="/portal/placement/details" component={isMobile ? PlacementDetailPageMob : PlacementDetailPage} />

        <Route className="component-body" path="/portal/third-party" component={ThirdParty} />
        <Route className="component-body" path="/portal/create-demand" component={CreateDemand} />
        <Route className="component-body" path="/portal/update-vehicle" component={UpdateVehicle} />
        <Route path="/portal/login" component={Login} />
        <Route path="/portal/wv" component={WebViews} />
        <Route path="/portal/oldportal/:id" component={OldPortalRedirect} />
      </Switch>
    </div>
  );
  // }
  return (
    <ThemeProvider theme={theme}>
      <StyledLoader active={props.loader} spinner text="Processing">
        <QueryParamProvider ReactRouterRoute={Route}>
          <Suspense fallback={<WELoader heightoffset={10} />}>
            {isMobile ? (
              <MobileLayout showAppBar={showAppBar}>{routes}</MobileLayout>
            ) : (
              <div className="App">{routes}</div>
            )}
          </Suspense>
        </QueryParamProvider>
      </StyledLoader>
      <Toaster />
    </ThemeProvider>
  );
};

function mapDispatchToProps(dispatch) {
  const loginForUser = appActions.forUser.static;
  return bindActionCreators({ loginForUser }, dispatch);
}

function mapStateToProps(state, props) {
  return {
    userInfo: getUser(state),
    loader: getLoader(state),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
